module.exports = __webpack_public_path__ + "static/img/govcard_white_02.14f6b5fa.svg";